/* eslint-disable indent */
import styled from 'styled-components';

export const Wrapper = styled.section`
  width: 100%;

  > .container {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-top: 11px;
    overflow: hidden;
    flex-wrap: wrap;

    .card {
      min-width: 480px;
      flex-grow: 1;
      margin-bottom: 20px;
    }

    @media (max-width: 1043px) { //TODO: entender isto
      justify-content: center;

      .card {
        min-width: 100%;
      }
    }
  }

  @media (max-width: 530px) {
    padding: 0px 21px 26px 21px;

    .simple-cross-card {
      display: none;
    }
  }
`;

export const CardGroup = styled.div`
  display: ${(props) => (props.isSomeoneInFullScreen && !props.isFullScreen ? 'none' : 'inline-flex')};
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  
  .cardContainer {
    flex: 1;
    max-width: ${(props) => (props.isFullScreen ? '100%' : 'calc(50% - 8px)')};
  }

  @media (max-width: 530px) {
    display: block;

    .cardContainer {
      flex: 0;
      max-width: 100%;
    }

    .cardContainer+.cardContainer{
      margin-left: 0;
    }
  }

`;

export const CardContainer = styled.div`
  position: ${(props) => (props.cardIsFullScreen ? 'relative' : 'inherit')};
  margin-top: ${(props) => (props.cardIsFullScreen ? '0px' : '16px')};
  width: 100%;
  height: ${(props) => (props.cardIsFullScreen ? '100vh' : 'auto')};
  display: ${(props) => (!props.cardIsFullScreen && props.someoneInFullScreen ? 'none' : 'block')};
  .card {
    max-width: 100%;
  }
`;

export const ChartContent = styled.div`
  min-height: 170px;
  height: 50%;
  width: 100%;
`;

export const MixerContent = styled.div`
  height: 335px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  .button{
    margin-top: 15px;
  }
`;

export const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  inset: 0;
  /* 
   * O wrapper do loading deve estar à frente de todos os outros 
   * componentes
  */
  z-index: 999999;
`;
